'use client';

import type { BaseComponentProps } from '../../base-component.types';
import type { AuditLogType } from '../../questions/Question.types';
import { AuditLogButton } from '../../questions/layout/AuditLogButton';
import { ResourceBar } from '../../resource';

type ContainerProps = BaseComponentProps & {
  auditLog?: AuditLogType[];
};

function Footer({ style, className, auditLog }: ContainerProps) {
  return (
    <ResourceBar
      style={style}
      className={className}
      edge="bottom"
      layout="split"
      start={
        auditLog &&
        auditLog.length > 0 && <AuditLogButton auditLog={auditLog} />
      }
    />
  );
}

export { Footer };
